import React from "react";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import SectionWrapper from "../components/SectionWrapper";
import {
    MISSION_MOTIFS,
    getMissionMotifLabel,
} from "pages/createMission/utils/missionMotifs";

const Motif = () => {
    const { data, language } = UseContext();
    const { toggle } = useModal();

    return (
        <SectionWrapper
            title={language.getValue("missionCreation.motif.title", "Motifs")}
            description={language.getValue(
                "missionCreation.motif.description",
                "Sélectionnez le motif de recours à l'intérim pour cette mission."
            )}
        >
            <div className={"flex flex-col gap-2"}>
                {MISSION_MOTIFS.map((item) => (
                    <div
                        key={item.type}
                        className={`ft-b text-gray-700 p-4 rounded-lg cursor-pointer ${
                            data.motif?.type === item.type
                                ? "border border-yellow-500 bg-yellow-50"
                                : "border border-gray-200"
                        }`}
                        onClick={() => {
                            toggle(item.modal);
                        }}
                    >
                        {getMissionMotifLabel(language, item)}
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
};

export default Motif;
